export const VenueBudgetsList = [
    {
        label: 'I don\'t yet have a budget',
        value: -1,
    },
    {
        label: '$500 - $1,500',
        value: 1500,
    },
    {
        label: '$1,500 - $5,000',
        value: 5000,
    },
    {
        label: '$5,000 - $10,000',
        value: 10000,
    },
    {
        label: '$10,000 - $30,000',
        value: 30000,
    },
    {
        label: '$30,000 - $50,000',
        value: 50000,
    },
    {
        label: '$50,000 - $75,000',
        value: 75000,
    },
    {
        label: '$75,000 - $125,000',
        value: 125000,
    },
    {
        label: '$125,000+',
        value: 9999999,
    },
];

export const EventFormats = {
    standingOnly: 'Standing only',
    theaterStyle: 'Theater-style seating',
    classroomStyle: 'Classroom-style seating',
    seatedMeal: 'Seated meal',
    passedHorsDoeuvres: 'Passed hors d\'oeuvres',
    buffetFormat: 'Buffet format',
    dropOffPlatters: 'Drop-off platters',
};

export const OutdoorSpacePreferences = {
    only: 'I only want to see venues with outdoor space',
    preferred: 'I prefer venues with outdoor space',
    not_necessary: 'Outdoor space is not necessary',
    required: 'Outdoor space required',
    not_required: 'Outdoor space not required',
};

export const FoodDrinkNeeds = {
    inhouse: 'I\'d like the food/drinks to be prepared and served during the event',
    dropoff: 'I\'m just looking to have drop-off food/drinks',
    bringing_own: 'I\'ll be bringing in my own food/drinks',
    none: 'There won\'t be any food or drinks at this event',
};

export const BudgetFlexibility = {
    somewhat: 'My budget is somewhat flexible',
    very: 'My budget is very flexible',
    not_flexible: 'My budget is not flexible',
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/lists.jsx